/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })
    $slideshowClassic.on( 'select.flickity', function( event, index ) {
      var progress =  ((index+1)/Shopify.theme.jsSlideshowClassic.number_of_slides*100) - 8;
      var id =$section.attr("id");
      $('#'+id+' .custom_style').html("<style>#"+id+" .slideshow-classic .flickity-page-dots .dot.is-selected::after{ width:"+progress+ "% }</style>");
    });
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;